"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomSlider } from "@/components/ui/custom-slider";
interface FloorsSectionProps {
  value?: {
    min: number;
    max: number;
  };
  onChange: (value: {
    min: number;
    max: number;
  }) => void;
}
const minRange = 1;
const maxRange = 10;
export function FloorsSection(t0) {
  const $ = _c(20);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = newValues => {
      onChange({
        min: newValues[0],
        max: newValues[1]
      });
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleValueChange = t1;
  let t2;
  if ($[2] !== value) {
    t2 = value || {
      min: 0,
      max: 0
    };
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const currentValue = t2;
  const t3 = currentValue.min === 0 ? minRange : currentValue.min;
  const t4 = currentValue.max === 0 ? maxRange : currentValue.max;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = [t3, t4];
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const sliderValue = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Array.from({
      length: 10
    }, _temp);
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const ticks = t6;
  let t7;
  if ($[8] !== handleValueChange) {
    t7 = newValues_0 => handleValueChange(newValues_0 as [number, number]);
    $[8] = handleValueChange;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["Minimum Floors", "Maximum Floors"];
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== sliderValue || $[12] !== t7) {
    t9 = <div className="relative h-6 flex items-center px-3"><CustomSlider value={sliderValue} onChange={t7} min={minRange} max={maxRange} step={1} isRange={true} ariaLabel={t8} rangeClassName="absolute bg-gray-600 rounded-full h-full" /></div>;
    $[11] = sliderValue;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      paddingLeft: "0.5rem"
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== sliderValue) {
    t11 = <div className="relative px-3"><div className="flex justify-between items-center" style={t10}>{ticks.map(tick => {
          const isSelected = tick === sliderValue[0] || tick === sliderValue[1];
          return <div key={tick} className="flex flex-col items-center gap-1"><div className={`w-px h-2 ${isSelected ? "bg-primary-600" : "bg-gray-400"}`} /><span className={`text-xs font-semibold ${isSelected ? "text-primary-600" : "text-gray-600"}`}>{tick === 10 ? "10+" : tick}</span></div>;
        })}</div></div>;
    $[15] = sliderValue;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t9) {
    t12 = <div className="space-y-6"><div className="space-y-4">{t9}{t11}</div></div>;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
}
function _temp(_, i) {
  return i + 1;
}